import gql from 'graphql-tag';

export const UNIQUE_NAME_GENERATOR_QUERIES = gql`
  query UniqNameGenerator($amount: Int!, $corp_client_id: Int) {
    getUniqueNames(amount: $amount, corp_client_id: $corp_client_id)
  }
`;
